module.exports = __webpack_public_path__ + "static/media/puerta_blanca.e8b4fef3.jpg";